export const cageInfo = [{
  id: 1,
  label: '钢筋笼编号',
  value: 'produceNumber'
},{
  id: 2,
  label: '项目',
  value: 'proName'
},{
  id: 3,
  label: '尺寸',
  value: 'sizeName'
},{
  id: 4,
  label: '配筋',
  value: 'reinforcementName'
},{
  id: 5,
  label: '块号',
  value: 'blockNumName'
},{
  id: 6,
  label: '制作人',
  value: 'createUserName'
},{
  id: 7,
  label: '质检人',
  value: 'steelCheckUserName'
},{
  id: 8,
  label: '质检时间',
  value: 'steelCheckTime'
},{
  id: 9,
  label: '质检结果',
  value: 'steelCheckResult'
  // value: {
  //   1: '合格',
  //   2: '不合格',
  //   3: '报废'
  // }
},{
  id: 10,
  label: '打印日期',
  value: 'printTime'
}]

export const mouldInfo = [{
  id: 1,
  label: '模具编号',
  value: 'mouldNum'
},{
  id: 2,
  label: '模具循环次数',
  value: 'currentCycleTime'
},{
  id: 3,
  label: '模具总次数',
  value: 'maxCycleTime'
},{
  id: 4,
  label: '模具类型',
  value: 'mouldTypeName'
},{
  id: 5,
  label: '模具尺寸',
  value: 'sizeName'
},{
  id: 6,
  label: '模具型号',
  value: 'mouldCode'
},{
  id: 7,
  label: '模具转向',
  value: 'turnName'
}]

export const ductpiedceInfo = [{
  id: 1,
  label: '环号',
  value: 'ringNum'
},{
  id: 2,
  label: '项目',
  value: 'proName'
},{
  id: 3,
  label: '管片编号',
  value: 'pipeNum'
},{
  id: 4,
  label: '入模时间',
  value: 'intoModTime'
},{
  id: 5,
  label: '出模时间',
  value: ''
},{
  id: 6,
  label: '出模人',
  value: ''
},{
  id: 7,
  label: '质检人',
  value: 'pipeCheckUserName'
},{
  id: 8,
  label: '质检时间',
  value: 'pipeCheckTime'
},{
  id: 9,
  label: '尺寸',
  value: 'sizeName'
},{
  id: 10,
  label: '配筋',
  value: 'reinforcementName'
},{
  id: 11,
  label: '块号',
  value: 'blockNumName'
},{
  id: 12,
  label: '注浆孔',
  value: 'groutingHolesName'
}]

